import { Check } from 'lucide-react'
import { cn } from '@/lib/utils'

export type StepKey = 'intent' | 'connect' | 'choose' | 'done'

interface StepperProps {
  current: StepKey
}

const STEPS: { key: StepKey; label: string }[] = [
  { key: 'intent', label: 'You' },
  { key: 'connect', label: 'Connect' },
  { key: 'choose', label: 'Confirm' },
  { key: 'done', label: 'Ready' },
]

export function Stepper({ current }: StepperProps) {
  const currentIndex = STEPS.findIndex(s => s.key === current)

  return (
    <ol className="flex items-center gap-2 sm:gap-4">
      {STEPS.map((step, i) => {
        const state = i < currentIndex ? 'done' : i === currentIndex ? 'active' : 'upcoming'
        return (
          <li key={step.key} className="flex items-center gap-2 sm:gap-3">
            <div
              className={cn(
                'flex h-7 w-7 items-center justify-center rounded-full border text-xs font-semibold transition-colors',
                state === 'done' && 'border-primary bg-primary text-primary-foreground',
                state === 'active' && 'border-primary text-primary',
                state === 'upcoming' && 'border-muted-foreground/30 text-muted-foreground'
              )}
            >
              {state === 'done' ? <Check className="h-3.5 w-3.5" /> : i + 1}
            </div>
            <span
              className={cn(
                'hidden text-sm font-medium sm:inline',
                state === 'upcoming' ? 'text-muted-foreground' : 'text-foreground'
              )}
            >
              {step.label}
            </span>
            {i < STEPS.length - 1 && (
              <span
                className={cn(
                  'h-px w-6 sm:w-10',
                  i < currentIndex ? 'bg-primary' : 'bg-muted-foreground/30'
                )}
              />
            )}
          </li>
        )
      })}
    </ol>
  )
}
